export default "__VITE_ASSET__6105dedb__"